import React, { Component } from 'react';
import Combobox from "react-widgets/Combobox";

import "react-widgets/styles.css";
import { requestBase, apiroot } from "./Fetch-helpers";
export default class ModelNumber extends Component {

    constructor(props) {
        super();

        //this.setState({ modelNumberByUser: "", waitForResult: false });
        this.state = { modelNumberByUser: "", waitForResult: false };

        //this.handleChange = this.handleChange.bind(this);
        this.postData = this.postData.bind(this);


    }

    render() {
        const modelNumber = this.props.modelNumber;

        /*if (this.props.isCustomModelString) {
            return (
                <div>
                    <input id="toggleEditModelNumber" className="modelNumber modelNumberEditable" type="text"  title="Нажмите <Enter>, чтобы сконфигурировать по введенной строке"
                        onKeyPress={this.postData} onChange={(e) => this.handleChange(e)} ></input>
                </div>
            );
        }
        else {
            return (
                <div>
                    <input id="toggleEditModelNumber" className={`modelNumber ${!this.props.isValid ? "modelNumberUnvalid" : ""}`} type="text" disabled={!this.props.isCustomModelString}
                        value={!this.props.isValid ? "Необходимо выбрать все обязательные параметры" : modelNumber} ></input>
                </div>
            );
        }*/

        if (this.props.isCustomModelString) {
            if (this.state.waitForResult) {
                return (
                    <div className="modelNumber modelNumberEditable">
                        <Combobox hideCaret busy hideEmptyPopup
                            onChange={value => this.setState({ modelNumberByUser: value })}
                            onKeyDown={this.postData}
                            title="Нажмите <Enter>, чтобы сконфигурировать по введенной строке"
                        />
                    </div>
                );
            } else {
                return (
                    <div className="modelNumber modelNumberEditable">
                        <Combobox hideCaret hideEmptyPopup
                            onChange={value => this.setState({ modelNumberByUser: value })}
                            onKeyDown={this.postData}
                            title="Нажмите <Enter>, чтобы сконфигурировать по введенной строке"
                        />
                    </div>
                );
            }
        }
        else {
            if (this.state.waitForResult) {
                return (
                    <div>
                        <div className={`modelNumber ${!this.props.isValid ? "modelNumberUnvalid" : ""}`}>
                            <Combobox busy
                                readOnly={!this.props.isCustomModelString}
                                value={!this.props.isValid ? "Идет процесс распознавания строки заказа..." : modelNumber}
                                hideCaret
                                hideEmptyPopup
                                title="Пожалуйста, подождите..."
                            />
                        </div>
                    </div>
                );
            } else {
                return (
                    <div>
                        <div className={`modelNumber ${!this.props.isValid ? "modelNumberUnvalid" : ""}`}>
                            <Combobox
                                readOnly={!this.props.isCustomModelString}
                                value={!this.props.isValid ? "Необходимо выбрать все обязательные параметры" : modelNumber}
                                hideCaret
                                hideEmptyPopup
                                title=""
                            />
                        </div>
                    </div>
                );
            }
        }


    }

    handleChange = (e) => {
        this.setState({ modelNumberByUser: e.target.value });
        alert("");
    }

    async postDataAsync() {

        const params = new Proxy(new URLSearchParams(window.location.search.toLowerCase()), {
            get: (searchParams, prop) => searchParams.get(prop),
        })

        const response = await fetch(apiroot + "Configuration/AutoConfigurate/" + (params.cfgid == null ? "" : params.cfgid),
            Object.assign({}, requestBase, {
            method: "post",
            headers: {
                'Accept': 'application/json,text/plain',// application/json, 
                'Content-Type': 'text/plain' //;charset=UTF-8
            },
            body: this.state.modelNumberByUser   //JSON.stringify(
        }));

        if (response.ok) {

            const data = await response.json();
            //console.log(JSON.stringify(data));
            //this.setState({ Model: data, loading2: false });

            this.props.updateConfiguration(data);
        }
        else {
            alert("Не удалось корректно распознать все опции в строке заказа");
        }
        //this.state.waitForResult = false;
        this.setState({ waitForResult : false});
        //this.setStateConfiguration (data)
        /*if (data.errorMessageString != null) {
            alert(data.errorMessageString);
            //    addNotification({
            //        title: 'Warning',
            //        native: true
            //    })
        }*/

    }

    postData = (event) => {
        if (event.key === 'Enter') {
            //this.state.waitForResult = true;
            this.setState({ waitForResult: true });
            this.postDataAsync();
            this.props.handleToggle();
        }
    }

}